<template>
  <layout-vendor-dashboard-inner
    :vendor-id="vendorId"
    :back-link="{ name: 'company-vendorId-dashboard', params: { vendorId } }">
    <products-view
      :vendor-id="vendorId"
      :override-list-configuration="listConfiguration" />
  </layout-vendor-dashboard-inner>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import ProductsView from "@/client/applications/justopp/views/Products";

export default {
  components: { ProductsView },
  layout: {
    component: "noContainer",
    params: {
      title: "justopp.vendorDeals.pageTitle",
      subTitle: "justopp.vendorDeals.pageSubtitle",
      containerClass: "margin-remove-vertical",
    },
  },
  middleware: {
    requireVendorOrAdmin: { vendorIdFromParam: "vendorId" },
  },
  props: {
    // vendor ID
    vendorId: {
      type: String,
      default: 0,
    },
  },
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "justopp.vendorDashboard.browserTitle",
  data() {
    return {
      listConfiguration: {},
      asyncData: {},
    };
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
